export interface PurchaseOrderLineStockIssue {
  id: string;
  stockItemId: string;
  purchaseOrderLineId: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  issued: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  batchNo: string;
  received: boolean;
  dateReceived: Date;
  selected: boolean;
  canDelete: boolean;
}
